import EventEditTabs from './EventEditTabs';

export default EventEditTabs;
